import { Box, Typography } from "@mui/material";
import { VolumeTypeEnum } from "../../../../../store/types/secureVolume.types";
import { DISPLAY_VOLUME_TYPES, VOLUME_TYPE_CONFIG } from "../types";

const LEGEND_TYPES = DISPLAY_VOLUME_TYPES.filter(
  (t) => t !== VolumeTypeEnum.InProgress,
);

export function VolumeLegend() {
  return (
    <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
      {LEGEND_TYPES.map((type) => (
        <Box
          key={type}
          sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
        >
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              bgcolor: VOLUME_TYPE_CONFIG[type].color,
            }}
          />
          <Typography variant="caption">
            {VOLUME_TYPE_CONFIG[type].label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
